<template>
	<div>
		<div v-for="(chunk, chunkIndex) in chunkAddress" :key="chunkIndex" class="row pb-2">
			<div v-for="(address, index) in chunk" :key="index" class="col-md-6">
				<div class="card-address border p-3 rounded mb-3 mb-md-0">
					<div v-if="canSelect" class="custom-control custom-radio custom-control-inline">
						<input
							:id="`card_address_${address.id}`"
							v-model="selected.id"
							type="radio"
							name="card_address_input"
							class="custom-control-input"
							:value="address.id"
							:data-checked="selected.id === address.id"
							@input="setAddress(address)"
						>
						<label
							class="custom-control-label font-16 font-weight-bold"
							:for="`card_address_${address.id}`"
						>
							{{ address.tag }}
						</label>
					</div>
					<div v-if="!canSelect">
						<span class="font-16 font-weight-bold">
							{{ address.tag }}
						</span>
					</div>

					<div v-if="canUpdate || canDelete" class="float-right">
						<a v-if="canUpdate" href="javascript:void(0)" @click="syncPropModal(address)">
							<i class="mdi mdi-square-edit-outline text-muted font-20" />
						</a>
						<template v-if="address.tag !== 'Principal'">
							<a v-if="canDelete" href="javascript:void(0)" @click="destroy(address.id)">
								<i class="mdi mdi-trash-can-outline text-danger font-20" />
							</a>
						</template>
					</div>
					<h5 class="mt-3">
						{{ address.people_contact }}
					</h5>

					<div :class="{ pointer: canSelect }" @click="setAddress(address)">
						<p class="mb-0">
							<span class="font-weight-semibold">Endereço:</span> {{ address.street }},
							{{ address.number }} - {{ address.neighborhood }}
						</p>
						<p class="mb-2">
							{{ address.zip_code }} - {{ address.city }} / {{ address.state }}
						</p>
						<p class="mb-1">
							<span class="font-weight-semibold">Telefone:</span> {{ address.phone }}
						</p>
						<p class="mb-0">
							<span class="font-weight-semibold">Celular:</span> {{ address.mobile }}
						</p>
					</div>
				</div>
			</div>
		</div>


		<modal-address
			ref="modal-address"
			:value.sync="selected"
			:show-modal="showForm"
			action="update"
			@close="showForm=!showForm"
			@created="pushCreated"
			@updated="update"
		/>
	</div>
</template>

<script>
export default {
    name: "CardAddress",

    model: {
        prop: 'value',
        event: 'input',
    },

    props: {
        addresses: {
            type: Array,
            default: () => {
                return []
            }
        },
        value: {
            type: Object,
            required: false,
            default: () => ({
                id: null,
                people_contact: null,
                phone: null,
            })
        },
        showModal: {
            default: false,
        },
        canUpdate: {
            type: Boolean,
            default: true,
            required: false
        },
        canDelete: {
            type: Boolean,
            default: true,
            required: false
        },
        canSelect: {
            type: Boolean,
            default: true,
            required: false
        }
    },
    data() {
        const _this = this;
        return {
            bindPropModal: _this.showModal,
            showForm: false,
        }
    },

    computed: {
        internalAddresses: {
            get() {
                return this.addresses
            },

            set(value) {
                this.$emit('update:addresses', value)
            }
        },
        chunkAddress() {
            if (!this.internalAddresses) {
                return []
            }

            if (this.internalAddresses.length <= 2) {
                return [this.internalAddresses]
            }

            return [this.internalAddresses.slice(0, 2), ...chunkArray(this.internalAddresses.slice(2), 2)]
        },

        selected: {
            get() {
                return this.value
            },

            set(value) {
                this.$emit('input', value)
            }
        },
    },

    beforeMount() {
        this.setInitialSelected();
    },

    methods: {
        setInitialSelected() {
            if (this.internalAddresses && this.internalAddresses.length > 0) {
                this.selected = this.internalAddresses[0];
            }
        },
        setAddress(address) {
            console.debug('setAddress', address)
            this.selected = address;
            this.$emit('changefreight', address.id)
        },
        syncPropModal(address) {
            this.selected = address
            this.$refs['modal-address'].address = address;
            // this.$emit('update:showModal', this.bindPropModal)
            this.showForm = true;
        },
        syncHammer(value) {
            this.bindPropModal = value;
            this.$emit('update:showModal', this.bindPropModal)
        },
        update(value) {
            let addresses = this.internalAddresses;

            this.internalAddresses = [];

            addresses.forEach((item, index) => {
                if (item.id === value.id) {
                    addresses[index] = {...addresses[index], ...value};
                }
            })

            this.internalAddresses = addresses;

            this.$emit('update-addresses', addresses)
        },
        pushCreated(address) {
            this.internalAddresses.push(address)
        },
        async destroy(id) {
            let addresses = this.internalAddresses;
            this.internalAddresses = [];

            try {
                const {data} = await this.$axios.delete(route('api.address.destroy', id))
                addresses.forEach((item, index) => {
                    if (item.id === id) {
                        addresses.splice(index, 1);
                    }
                })
                this.internalAddresses = addresses;
            } catch (e) {
                toastError();
            }
        },


    }
}
</script>

<style scoped lang="scss">
.card-address:hover {
    box-shadow: 4px 4px 8px 0 rgb(122 122 144 / 20%);
}
</style>
